import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=18d69193&scoped=true&"
import script from "./CustomerManagement.vue?vue&type=script&lang=js&"
export * from "./CustomerManagement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=18d69193&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d69193",
  null
  
)

export default component.exports